import theme from "app/Theme/Theme";
import React from "react";
import Svg, { Path } from "react-native-svg";

const ClearIcon = ({ width, height, color }) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 11 11"
      preserveAspectRatio="xMidYMin meet"
    >
      <Path
        d="M9.52822 10.599L5.37036 6.43461L1.21251 10.599L0.28418 9.67067L4.44857 5.51282L0.28418 1.35496L1.21251 0.426636L5.37036 4.59103L9.52822 0.433173L10.45 1.35496L6.29215 5.51282L10.45 9.67067L9.52822 10.599Z"
        fill={color}
      />
    </Svg>
  );
};

ClearIcon.defaultProps = {
  width: 11,
  height: 11,
  color: theme.colors["neutral.white"],
};

export default ClearIcon;
